module.exports = __webpack_public_path__ + "static/media/businessModel.6408474a.png";